import { ObservedSuggestedTextInput } from './ObservedSuggestedTextInput';
import { SuggestionInput } from './SuggestionInput';
import type { SuggestedTextInputProps } from './suggested-text-input.types';

export function SuggestedTextInput(props: SuggestedTextInputProps) {
  const { schemaId, field } = props;
  if (schemaId && field) {
    return (
      <ObservedSuggestedTextInput
        key={`${schemaId}:${field}`}
        {...props}
        schemaId={schemaId}
        field={field}
      />
    );
  }

  return <SuggestionInput {...props} suggestions={[]} isLoading={false} />;
}
